// Drawer.js - Creative Glass Mobile Menu
import React, { useState } from "react";
import {
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  Box
} from "@mui/material";
import { Link } from "react-router-dom";
import { CiMenuFries } from "react-icons/ci";
import { AiOutlineClose } from "react-icons/ai";

const DrawerComponent = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  // Drawer Paper Styles for Glass Effect
  const glassDrawerStyle = {
    width: '100%',
    maxWidth: '350px',
    height: '100%',
    background: 'var(--glass-bg)',
    backdropFilter: 'blur(30px)',
    WebkitBackdropFilter: 'blur(30px)',
    borderRight: '1px solid rgba(255, 255, 255, 0.4)',
    boxShadow: 'var(--shadow-lg)'
  };

  const menuItems = [
    { text: 'HOME', path: '/' },
    { text: 'ABOUT US', path: '/about' },
    { text: 'PRODUCTS', path: '/products' },
    { text: 'CLIENTELE', path: '/clientele' },
    { text: 'CAREERS', path: '/careers' },
    { text: 'CONTACT US', path: '/contact' }
  ];

  return (
    <>
      <Drawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        anchor="right"
        PaperProps={{
          style: glassDrawerStyle
        }}
      >
        {/* Header with Close Button */}
        <Box sx={{ p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <img style={{ width: '120px' }} src="./images/dbase.png" alt="logo" />
          <IconButton
            onClick={() => setOpenDrawer(false)}
            sx={{
              background: 'rgba(255,255,255,0.5)',
              '&:hover': { background: 'var(--primary-orange)', color: 'white' },
              transition: 'all 0.3s'
            }}
          >
            <AiOutlineClose size={24} />
          </IconButton>
        </Box>

        <Divider sx={{ borderColor: 'rgba(0,0,0,0.05)' }} />

        {/* Menu Items with Animation */}
        <List sx={{ p: 2 }}>
          {menuItems.map((item, index) => (
            <React.Fragment key={item.text}>
              <ListItem
                onClick={() => setOpenDrawer(false)}
                disablePadding
                sx={{
                  mb: 2,
                  animation: `slideDown 0.4s ease forwards ${index * 0.1}s`,
                  opacity: 0,
                  transform: 'translateY(-20px)'
                }}
              >
                <Link
                  to={item.path}
                  className="nav-link"
                  style={{
                    fontSize: '1.2rem',
                    width: '100%',
                    display: 'block',
                    padding: '1rem',
                    borderRadius: '12px',
                    background: 'rgba(255,255,255,0.3)'
                  }}
                >
                  {item.text}
                </Link>
              </ListItem>
            </React.Fragment>
          ))}
        </List>
      </Drawer>

      {/* Hamburger Icon */}
      <IconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        sx={{
          color: "var(--text-black)",
          background: 'rgba(255,255,255,0.5)',
          backdropFilter: 'blur(4px)',
          borderRadius: '12px',
          '&:hover': { background: 'rgba(255,255,255,0.8)' }
        }}
      >
        <CiMenuFries size={24} />
      </IconButton>
    </>
  );
};

export default DrawerComponent;

